import VideoUrlDecoderMixin from './videoUrlDecoder';

export default {
  mixins: [VideoUrlDecoderMixin],
  methods: {
    getThumnail(src) {
      if (src.includes('youtube.com') || src.includes('youtu.be')) {
        const videoId = this.getYoutubeVideoId(src);

        return 'https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg';
      } else if (src.includes('vimeo.com')) {
        const videoId = this.getVimeoVideoId(src);

        const videoDetails = this.httpGet(`https://vimeo.com/api/v2/video/${videoId}.json`);

        return videoDetails[0].thumbnail_medium;
      } else if (src.includes('spark.adobe.com') || src.includes('express.adobe.com')) {
        return '/images/ExpressThumbnail.svg';
      } else {
        return src;
      }
    },
    httpGet(url) {
      const xmlHttp = new XMLHttpRequest();
      xmlHttp.open('GET', url, false);
      xmlHttp.send(null);

      return JSON.parse(xmlHttp.responseText);
    },
  },
};
